import { Button, Layout, Menu } from 'antd'
import styled from 'styled-components'

export const AvatarContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  transition: 0.25s all linear;
  .avatar-info {
    margin-left: 16px;
    transition: 0.25s all linear;
    .name {
      margin: 0;
      color: #fff;
      font-size: 1.4rem;
      line-height: 1.5;
      white-space: nowrap;
    }
    .role {
      margin: 0;
      color: ${(props) => props.theme?.colors?.gray300};
      font-size: 1.2rem;
      line-height: 1.5;
      text-transform: capitalize;
      white-space: nowrap;
    }
  }
`

export const StyledExpandIcon = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
  vertical-align: middle;
  .anticon {
    font-size: 12px !important;
  }
`
export const StyleLogoImg = styled.img`
  cursor: pointer;
`

export const StyledButton = styled(Button)`
  &.collapse--button {
    margin-right: 24px;
    padding-left: 6px;
    color: ${(props) => props.theme?.colors?.white};
    .anticon {
      font-size: 1.8rem;
    }
    svg {
      width: 24px;
      height: 24px;
    }
  }
`

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 2.4rem;
  line-height: 1;
  height: 65px;
  svg {
    width: auto;
    height: 1em;
  }
`

export const StyledNavigationMenu = styled(Menu)`
  width: 100%;
  .ant-menu-item {
    width: 100%;
    margin: 0 !important;
    white-space: normal;
    img {
      width: 24px;
      height: 24px;
    }
    .ant-menu-title-content {
      line-height: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }
  .ant-menu-item,
  .ant-menu-submenu-title {
    padding: 2px !important;
  }
  .ant-menu-sub {
    padding-left: 48px;
  }
  &.ant-menu-inline,
  &.ant-menu-inline-collapsed {
    border-right: 0;
  }
  &.menu--top {
    min-height: 0px;
    flex: 1;
  }
  &.menu--bottom {
  }
  .ant-menu-item-icon {
    margin-top: 8px;
  }
  .ant-menu-item:first-child {
    .ant-menu-item-icon {
      margin-top: 8px;
    }
  }
`

export const StyledNavigationWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  .ant-menu-item {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 65px;
    border-bottom: 1px solid var(--color-primary-107);
    .ant-menu-title-content {
      font-size: 1rem;
      font-weight: 600;
      margin-left: 0px;
    }
  }
  }
`

export const StyledNavigation = styled(Layout.Sider)`
  min-height: 100vh;
  overflow: overlay;
  max-height: 100%;
  color: ${(props) => props.theme?.colors?.white};
  .divider {
    border-color: ${({ theme }) => theme?.colors?.gray100 || '#F2F2F2'};
    margin-top: 24px;
    margin-bottom: 24px;
    opacity: 0.2;
  }
  .ant-layout-sider-children {
    display: flex;
    height: auto;
    min-height: 100%;
  }
  &.ant-layout-sider-collapsed {
    ${StyledButton} {
      &.collapse--button {
        margin-right: 0;
      }
    }
    ${StyleLogoImg} {
      display: none;
    }
    ${LogoContainer} {
      justify-content: center;
    }
    ${AvatarContainer} {
      justify-content: center;
      .avatar-info {
        display: none;
      }
    }
    ${StyledNavigationMenu} {
      .ant-menu-item {
        margin: 0;
      }
      .ant-menu-item,
      .ant-menu-submenu-title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px !important;
        text-align: center;
        .ant-menu-title-content {
          display: none;
        }
      }
      .ant-menu-submenu {
        .ant-menu-submenu-title {
          .ant-menu-title-content {
            display: none;
          }
        }
      }
    }
  }
`

export const StyledWrapper = styled(Layout)`
  background-color: white;
  overflow-x: hidden;
`

export const StyledContainer = styled(Layout)`
  display: flex;
  .ant-layout-sider-collapsed {
    flex: 1 1 65px !important;
    width: 65px !important;
    min-width: 65px !important;
    max-width: 65px !important;
  }
  &.stickyMenu {
    .StyledNavigation {
      .StyledNavigationWrapper {
        position: sticky;
        top: 0;
      }
    }
  }

  &.layout-sidebar-fixed {
    height: 100vh;
    max-height: 100vh;
    .ant-layout-sider {
      max-height: 100%;
      background: ${({ theme }) => theme?.colors?.primary};
    }
    .layout-main-header {
      display: flex;
      min-height: 0;
      flex: 1;
      flex-direction: column;
    }
    .layout-main-body {
      display: flex;
      min-height: 0;
      flex: 1;
      flex-direction: column;
    }
  }
  .icon-bar {
    width: 40px;
    height: 40px;
    cursor: pointer;
    svg {
      fill: var(--gray-2);
    }
  }
  .ant-menu-item-active {
    background-color: var(--color-primary-109);
  }
  .ant-menu-item-selected {
    background-color: var(--color-primary-109) !important;
    color: white !important;
  }
  .ant-menu-item:hover {
    color: white;
  }
`
